// extracted by mini-css-extract-plugin
export default {"uikit-mrkdwn":"uikit-mrkdwn__cKH+1"};